"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ImprovementProviders = exports.ImprovementProvider = exports.ImprovementProviderSearch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var lookup_1 = require("../code-bench-panel/lookup/lookup");
var svg_icons_1 = require("../svgs/svg-icons");
var conditional_1 = require("../conditional/conditional");
var ui_common_1 = require("@codametrix/ui-common");
var invoice_editor_1 = require("../invoice-editor/invoice-editor");
var ui_components_1 = require("@codametrix/ui-components");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_2 = require("@codametrix/ui-common");
var reducers = ui_common_1.AmplifyCore.reducers;
var DocumentStatus = ui_common_1.commonEnums.DocumentStatus, FeedbackMeta = ui_common_1.commonEnums.FeedbackMeta, ProviderType = ui_common_1.commonEnums.ProviderType;
var conditionalUtils = ui_common_1.AmplifyCore.conditionalUtils;
var InvoiceEditorActions = ui_common_1.commonActions.InvoiceEditor;
var documentStatusOptions = [
    {
        value: DocumentStatus.OPEN,
        label: 'Open'
    },
    {
        value: DocumentStatus.RESOLVED,
        label: 'Resolved'
    },
    {
        value: DocumentStatus.INCOMPLETE,
        label: 'Incomplete'
    },
    {
        value: DocumentStatus.NOT_CORRECTED,
        label: 'Not corrected'
    }
];
var ImprovementProviderSearch = /** @class */ (function (_super) {
    __extends(ImprovementProviderSearch, _super);
    function ImprovementProviderSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleProviderSearch = function (codeQuery) {
            var context = __assign(__assign({}, codeQuery.context), { searchType: InvoiceEditorActions.PERFORMING_PROVIDER_RESULTS, processInstance: _this.props.processInstance, providerType: ui_common_1.commonEnums.ProviderType.REFERRING_PROVIDER, shouldFilterActive: true, shouldFilterOutExternalProviders: true });
            _this.props.onProviderSearch(__assign(__assign({}, codeQuery), { context: context }));
        };
        _this.handleProviderAdd = function (provider) {
            var _a;
            var providerIdentifier = reducers.getProviderInfo(provider);
            var proivderName = provider === null || provider === void 0 ? void 0 : provider.displayName;
            var providerQueryStatus = ((_a = _this.props.improvement) === null || _a === void 0 ? void 0 : _a.provider_query)
                ? DocumentStatus.OPEN
                : null;
            var isExistingProvider = _this.props.improvement.providers.some(function (pr) { return pr.provider_number === providerIdentifier.number; });
            if (isExistingProvider) {
                var feedback = {
                    message: "Provider ".concat(proivderName, " already exists, Choose a different provider."),
                    meta: FeedbackMeta.WARNING,
                    dismissable: true
                };
                _this.props.showAmplifyFeedback(feedback);
            }
            if (providerIdentifier.number && !isExistingProvider) {
                var improvementRequest = {
                    processInstance: _this.props.processInstance,
                    documentImprovement: _this.props.improvement,
                    improvementProvider: {
                        provider_number: providerIdentifier.number,
                        provider_name: proivderName,
                        provider_query_status: providerQueryStatus,
                        deleted: false
                    }
                };
                _this.props.onProviderAdd(improvementRequest);
            }
        };
        return _this;
    }
    ImprovementProviderSearch.prototype.render = function () {
        var _a = this.props, improvementsAction = _a.improvementsAction, providerSearchResults = _a.providerSearchResults;
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "improvement-provider-search" }, { children: (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({}, improvementsAction, { children: (0, jsx_runtime_1.jsx)(lookup_1.Lookup, __assign({}, invoice_editor_1.DEFAULT_ARGS, { autoFocus: true, showSearchButton: false, onSearchSelection: this.handleProviderAdd, onSearch: this.handleProviderSearch, searchResults: providerSearchResults, actionPrefix: '', autoSearch: true, placeholderText: 'Add provider', resultFormatter: invoice_editor_1.resultFormatterV2 })) })) })));
    };
    ImprovementProviderSearch.displayName = 'ImprovementProviderSearch';
    return ImprovementProviderSearch;
}(react_1["default"].Component));
exports.ImprovementProviderSearch = ImprovementProviderSearch;
var ImprovementProvider = /** @class */ (function (_super) {
    __extends(ImprovementProvider, _super);
    function ImprovementProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.handleProviderDelete = function (ev) {
            ev.preventDefault();
            var improvementRequest = {
                processInstance: _this.props.processInstance,
                documentImprovement: _this.props.improvement,
                improvementProvider: {
                    provider_guid: _this.props.provider.provider_guid
                }
            };
            _this.props.onProviderRemove(improvementRequest);
        };
        _this.handleProviderUpdate = function (statusObj) {
            var _a;
            _this.setState({
                providerQueryStatus: statusObj.detail.value
            });
            var improvementRequest = {
                processInstance: _this.props.processInstance,
                documentImprovement: _this.props.improvement,
                improvementProvider: {
                    provider_guid: (_a = _this.props.provider) === null || _a === void 0 ? void 0 : _a.provider_guid,
                    provider_query_status: statusObj.detail.value,
                    deleted: false
                }
            };
            _this.props.onProviderUpdate(improvementRequest);
        };
        _this.state = {
            providerQueryStatus: _this.props.provider.provider_query_status
        };
        _this.handleProviderDelete = _this.handleProviderDelete.bind(_this);
        _this.handleProviderUpdate = _this.handleProviderUpdate.bind(_this);
        return _this;
    }
    ImprovementProvider.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b, _c, _d;
        if (((_a = prevProps === null || prevProps === void 0 ? void 0 : prevProps.provider) === null || _a === void 0 ? void 0 : _a.provider_query_status) !==
            ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.provider) === null || _c === void 0 ? void 0 : _c.provider_query_status)) {
            this.setState({
                providerQueryStatus: (_d = this.props.provider) === null || _d === void 0 ? void 0 : _d.provider_query_status
            });
        }
    };
    ImprovementProvider.prototype.render = function () {
        var _a;
        var _b = this.props, provider = _b.provider, improvement = _b.improvement, improvementsAction = _b.improvementsAction;
        var documentStatusStyle = [
            'provider-status',
            this.state.providerQueryStatus &&
                "provider-status-".concat((_a = this.state.providerQueryStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase())
        ];
        var providerReasonView = conditionalUtils.capabilityValue(improvementsAction === null || improvementsAction === void 0 ? void 0 : improvementsAction.actionable) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_components_1.SelectList, { name: "provider-status-".concat(provider.provider_guid), options: documentStatusOptions, value: provider.provider_query_status, onChange: this.handleProviderUpdate }), (0, jsx_runtime_1.jsx)("label", __assign({ className: "provider-status-select-label" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeChevronDownSVG20", svgIconSize: "16", svgIconClass: "select-checvron" }) }))] })) : ((0, jsx_runtime_1.jsx)("span", __assign({ className: "provider-reason-label" }, { children: ui_common_2.objectUtils.capitalize(provider.provider_query_status) })));
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "improvement-provider" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "provider-row-left" }, { children: [(improvement === null || improvement === void 0 ? void 0 : improvement.provider_query) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])(documentStatusStyle) }, { children: providerReasonView }))), (0, jsx_runtime_1.jsx)("span", __assign({ className: "provider-name" }, { children: provider.provider_name }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "provider-row-right" }, { children: (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({}, improvementsAction, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "provider-remove", onClick: this.handleProviderDelete }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeCancelCircle", svgIconClass: "improvement-provider-remove", svgIconSize: "18" }) })) })) }))] }), provider.provider_guid));
    };
    ImprovementProvider.displayName = 'ImprovementProvider';
    return ImprovementProvider;
}(react_1["default"].Component));
exports.ImprovementProvider = ImprovementProvider;
var ImprovementProviders = function (props) {
    var improvement = props.improvement, improvementsAction = props.improvementsAction, processInstance = props.processInstance, onProviderUpdate = props.onProviderUpdate, onProviderRemove = props.onProviderRemove;
    var providers = improvement.providers;
    var providersView = providers === null || providers === void 0 ? void 0 : providers.map(function (provider, idx) {
        return ((0, jsx_runtime_1.jsx)(ImprovementProvider, { provider: provider, processInstance: processInstance, improvement: improvement, improvementsAction: improvementsAction, onProviderUpdate: onProviderUpdate, onProviderRemove: onProviderRemove }, idx));
    });
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "improvement-providers" }, { children: providersView }));
};
exports.ImprovementProviders = ImprovementProviders;
exports.ImprovementProviders.displayName = 'ImprovementProviders';
//# sourceMappingURL=improvement-provider.js.map